<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      background-color: #f6f6f6;
      padding: 10px;
      display: flex;
      flex-direction: column;
    "
  >
    <van-tabs v-model:active="state.active" @change="onTabChange">
      <van-tab title="待签收" :name="0"></van-tab>
      <van-tab title="已签收" :name="1"></van-tab>
    </van-tabs>
    <div style="overflow-y: auto; flex: 1; margin-top: 10px">
      <van-pull-refresh v-model="state.isRefresh" @refresh="onRefresh">
        <van-list
          v-model:loading="state.loading"
          v-model:error="state.error"
          :error-text="state.errorMsg"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="year in state.listData" :key="year">
            <ul
              style="
                font-size: 16px;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.6);
              "
            >
              {{
                year.label
              }}
            </ul>
            <div
              v-for="item in year.children"
              :key="item"
              style="
                background-color: #fff;
                border-radius: 10px;
                position: relative;
                font-size: 13px;
                margin-top: 10px;
              "
              @click="toDetail(item)"
            >
              <ul
                style="
                  display: flex;
                  align-items: center;
                  padding: 10px;
                  border-bottom: 1px solid #f6f6f6;
                "
              >
                <li style="flex: 1; font-size: 14px">
                  {{ item.payroll_name }}
                </li>
                <van-badge dot v-if="state.active != 1">
                  <van-icon :size="20" color="#a2a2a2" name="comment-o" />
                </van-badge>
              </ul>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 20px;
                  color: #333;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <ul style="font-weight: 500; font-size: 16px">
                    {{
                      item.payroll_month + "月"
                    }}
                  </ul>
                  <ul style="font-size: 11px; color: #a2a2a2; margin-top: 3px">
                    {{
                      item.payroll_year
                    }}
                  </ul>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <ul
                    style="
                      font-size: 16px;
                      display: flex;
                      align-items: flex-end;
                      font-weight: 600;
                      color: #f00;
                    "
                  >
                    <text
                      style="
                        font-size: 13px;
                        margin-bottom: 1px;
                        font-weight: 500;
                      "
                      >￥</text
                    >
                    {{
                      $priceFormat(item.net_salary)
                    }}
                  </ul>
                  <ul style="font-size: 11px; color: #a2a2a2; margin-top: 3px">
                    发放金额
                  </ul>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <ul style="font-size: 16px">
                    {{
                      $bankAccountFormat(item.bank_account)
                    }}
                  </ul>
                  <ul style="font-size: 11px; color: #a2a2a2; margin-top: 3px">
                    收款账户
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup
      v-model:show="state.showDetail"
      position="right"
      teleport="body"
      style="width: 100%; height: 100%"
    >
      <c_Detail
        :id="state.selectItem.id"
        v-if="state.showDetail"
        @close="onCheckClose"
      ></c_Detail>
    </van-popup>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { salary_list } from "@/http/api";
import constant from "@/utils/constant";
import c_Detail from "./Detail.vue";
export default {
  components: {
    c_Detail,
  },
  setup() {
    const state = reactive({
      params: {
        limit: constant.pageSize,
        page: 0,
        is_confirm: 0,
      },
      listData: [],
    });
    onMounted(() => {});

    const onLoad = () => {
      state.loading = true;
      state.params.page++;

      salary_list(state.params)
        .then((res) => {
          state.loading = false;
          state.isRefresh = false;
          if (res.status == 200) {
            const list = res.data.data?.list;

            const currList = [...(state.listData || []), ...list];

            if (currList.length < constant.pageSize) {
              state.finished = true;
            }

            const yearArr = [...new Set(currList.map((m) => m.payroll_year))];

            let resList = [];
            yearArr.forEach((e) => {
              resList.push({
                label: e,
                children: currList.filter((w) => w.payroll_year === e),
              });
            });

            state.listData = resList;
          }
        })
        .catch((err) => {
          state.error = true;
          state.errorMsg = err;
          state.loading = false;
          state.isRefresh = false;
        });
    };

    const onRefresh = () => {
      state.isRefresh = true;
      state.params.page = 0;
      state.listData = [];
      state.finished = false;
      onLoad();
    };

    const toDetail = (item) => {
      state.selectItem = item;
      state.showDetail = true;
    };

    const onCheckClose = (isRef) => {
      state.showDetail = false;
      if (isRef) onRefresh();
    };

    const onTabChange = (value) => {
      state.params.is_confirm = value;
      onRefresh();
    };
    return { state, toDetail, onLoad, onRefresh, onCheckClose, onTabChange };
  },
};
</script>
<style scoped></style>
